// Configuración de endpoints según el entorno
//
// En desarrollo local (NODE_ENV === 'development'):
//   - BASE_URL apunta a la rama remota de testing en Vercel (por ejemplo, userData)
//   - Así puedes probar el frontend local contra el backend de la rama que quieras
//
// En producción (NODE_ENV === 'production'):
//   - BASE_URL es '' (cadena vacía)
//   - Las llamadas serán relativas y apuntarán al mismo dominio donde está desplegada la app (main)
//   - No es necesario cambiar nada al desplegar en main

const isDevelopment = process.env.NODE_ENV === 'development';

const BASE_URL = isDevelopment 
  ? 'https://museo-viajero-web2-git-userdata-clod2008s-projects.vercel.app' // Cambia aquí la rama para pruebas locales
  : ''; // En producción, llamadas relativas

// Configuración de endpoints
export const ENDPOINTS = {
  // Endpoints de usuarios
  USERS: {
    LIST: `${BASE_URL}/api/listUsers`,
    DELETE: `${BASE_URL}/api/deleteUser`,
    CREATE: `${BASE_URL}/api/createUser`,
    UPDATE: `${BASE_URL}/api/updateUser`,
  },
  // Endpoints de autenticación
  AUTH: {
    LOGIN: `${BASE_URL}/api/auth/login`,
    LOGOUT: `${BASE_URL}/api/auth/logout`,
  },
};

// Función helper para construir URLs
export const buildUrl = (endpoint, params = {}) => {
  let url = endpoint;
  if (Object.keys(params).length > 0) {
    const queryString = new URLSearchParams(params).toString();
    url += `?${queryString}`;
  }
  return url;
};

// Función helper para hacer peticiones a los endpoints
export const fetchEndpoint = async (endpoint, options = {}) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const response = await fetch(endpoint, {
    ...defaultOptions,
    ...options,
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Error en la petición');
  }

  return response.json();
}; 